import env_config from "./env";

const AppConfiguration = env_config;
export default AppConfiguration;
